export default __webpack_public_path__ + "static/media/game_4_r.b096b4f1.png";